module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employee/templates/payslips/Layout.ejs -->\n<div id="content" class="wrapper wrapper-content">\n    <div class="row">\n        <div class="col-md-12 col-lg-12">\n            <div class="ibox float-e-margins">\n                <div class="ibox-title">\n                    <h5>Payslips</h5>\n                </div>\n                <div class="tab-content js-tab-content">\n                    <div class="js-leave-loader ibox-content">\n                        <div class="row">\n                            <div class="col-xs-12" style="height: 200px">\n                                <div class="loader">\n                                    '+
((__t=( require('commons/templates/Spinner.html')() ))==null?'':__t)+
'\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employee/templates/payslips/Layout.ejs
// module id = 1057
// module chunks = 1